// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-links[data-v-663bac2f] {\n  display: grid;\n  grid-auto-columns: minmax(0, 1fr);\n  grid-auto-flow: column;\n  -moz-column-gap: 0.5rem;\n       column-gap: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
